<div class="generic-drag-drop">
  @for (group of groups; track group.uid) {
    <div
      class="my-4 overflow-hidden rounded border border-solid border-slate-200 bg-white"
    >
      <pr-service-group-header
        class="border-0 border-b border-solid border-slate-200 bg-slate-50"
        [group]="group"
        (groupChange)="emitChanges()"
        (deleted)="deleteGroup(group)"
      />
      <div
        cdkDropList
        [cdkDropListData]="group"
        [cdkDropListEnterPredicate]="canEnterGroup"
        (cdkDropListDropped)="drop($event)"
      >
        @for (entry of group.serviceCodes; track entry) {
          <div cdkDrag cdkDragLockAxis="y" [cdkDragData]="entry">
            <div class="flex items-center gap-4">
              <mat-icon cdkDragHandle>drag_indicator</mat-icon>
              <span class="flex-1">{{ entry | map: getCodeName }}</span>
              <pr-increase-decrease-input
                [decreaseDisabled]="entry.quantity <= 1"
                (decrease)="decreaseQty(entry)"
                (increase)="increaseQty(entry)"
              >
                <label>Quantity</label> {{ entry.quantity }}
              </pr-increase-decrease-input>
              <button mat-icon-button color="warn" (click)="deleteEntry(entry)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        } @empty {
          <div class="is-empty-placeholder">No item codes</div>
        }
      </div>
      @if (acceptsNewCodes) {
        <pr-add-service-code
          [serviceCodeType]="group.serviceCodeType"
          [slim]="true"
          (codeSelected)="addCode(group, $event)"
        />
      }
    </div>
  }
</div>
